import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateTree, setIsSaving } from '../scripts/tree-slice';
import GraphButton from '../../GraphButton';

const SaveDataBtn = () => {
  const dispatch = useDispatch();
  const isSaving = useSelector((state) => state.tree.isSaving);
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    // debug-console.log('[Use Effect] ---------isSaving');
    if (isSaving) {
      saveData(setLocalIsSaving);
    }
  }, [isSaving]);

  const setLocalIsSaving = (val) => {
    dispatch(setIsSaving(val));
  };

  const saveData = async (callback) => {
    try {
      // debug-console.log('saveData: user.userId = ' + user.userId);
      const saveDataSuccsess = await dispatch(updateTree({ userId: user.userId, callback }));
      const originalPromiseResult = unwrapResult(saveDataSuccsess);
      // debug-console.log('Finish saving:');
      // debug-console.log(originalPromiseResult);
      // await dispatch(setIsSaving(false));
    } catch (err) {
      // debug-console.log(err);
      // handel smt
    }
  };

  return (
    <GraphButton
      id="save"
      label="Lưu"
      onClick={() => dispatch(setIsSaving(true))}
      title={`Lưu dữ liệu ${user === null ? '(cần đăng nhập)' : ''}`}
      disabled={user === null}
    />
  );
};

export default SaveDataBtn;
